var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupermarket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6322",
    "data-name": "Rectangle 6322",
    width: 42.649,
    height: 36.137,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34942",
    "data-name": "Group 34942",
    transform: "translate(-4097 -5406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(4097 5406)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34871",
    "data-name": "Group 34871",
    transform: "translate(4113 5425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34870",
    "data-name": "Group 34870",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24372",
    "data-name": "Path 24372",
    d: "M0,15.485c.388-1.124.781-2.246,1.164-3.373.317-.933.637-1.864.924-2.806.1-.328.26-.409.589-.408q6.107.018,12.213.008h.531V2.671h1.81V0H40.889V2.631h1.76v8.51H40.939a2.127,2.127,0,0,0-.035.229,23.8,23.8,0,0,0,.5,6.373,22.687,22.687,0,0,1,.368,5.892H40.9v12.5H17.259V34.386H2.066V15.569H0v-.084M41.327,4.018H16.8V9.78H41.327ZM17.2,33v-9.35c-.169,0-.307,0-.445,0s-.267-.012-.359-.017a25.765,25.765,0,0,1,.712-8H3.419V33Zm20.131,1.768h2.2V23.677H18.6v11.11h2.206V25.012H37.335Zm2.2-23.593H18.6v3.058H39.538Zm-9.772,23.62h6.192V26.336H29.766Zm-7.6,0h6.212V26.353H22.163ZM18.594,2.621H39.53V1.342H18.594Zm-3.178,7.623c-.383,0-.742.018-1.1-.005a.44.44,0,0,0-.532.368c-.3.981-.639,1.95-.961,2.924-.075.228-.149.458-.226.694h4.6V11.135H15.455c-.014-.306-.025-.577-.039-.891m20.439,9.12c-.169-.956-.334-1.88-.495-2.806-.165-.952-.163-.952-1.122-.952H31.989v3.759ZM22.926,15.629l-.651,3.732h3.867V15.629Zm-5.115,3.732h3.1c.217-1.249.43-2.473.653-3.756H19.481c-1.006,0-1.013,0-1.19.973-.165.911-.315,1.825-.48,2.783m18.807-3.729a.553.553,0,0,0-.022.145c.193,1.133.384,2.266.6,3.4.017.089.2.2.314.206.54.022,1.082.01,1.622.01h1.192c-.227-1.3-.441-2.526-.655-3.757Zm-6.034,0H27.529v3.732h3.056Zm5.376,5.124H32v1.531H35.96ZM22.17,22.279h3.973V20.75H22.17ZM12.5,10.244c-.359,0-.636.017-.911,0a.393.393,0,0,0-.471.333c-.307.976-.639,1.944-.961,2.914-.081.242-.161.485-.25.755.168.009.277.02.386.021.864.011.864.01,1.142-.826.349-1.046.7-2.092,1.065-3.192M4.54,14.263c.349,0,.626-.02.9.005.289.028.408-.086.493-.358.343-1.081.713-2.154,1.07-3.23.042-.127.072-.259.119-.435-.379,0-.71-.014-1.038.009a.359.359,0,0,0-.257.191c-.428,1.241-.84,2.487-1.285,3.818m16.24,6.492H17.709v1.557H20.78ZM9.811,10.269c-1.227-.084-1.227-.084-1.586.988-.084.25-.166.5-.25.749-.244.733-.488,1.466-.753,2.257.345,0,.635-.017.921.005s.384-.089.462-.345c.226-.742.486-1.474.731-2.21.156-.471.31-.942.475-1.444m-5.343-.025c-.35,0-.628.022-.9-.005-.293-.03-.406.092-.491.36-.344,1.081-.713,2.154-1.07,3.231-.042.125-.065.256-.11.432.377,0,.708.012,1.037-.007a.326.326,0,0,0,.24-.16c.431-1.254.847-2.512,1.295-3.85M37.355,22.28h3.068V20.749H37.355Zm-9.83.006h3.063V20.751H27.525Z",
    transform: "translate(0 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24373",
    "data-name": "Path 24373",
    d: "M36.2,7.387a.467.467,0,0,1,.692.293c.139.326.316.636.512,1.025.2-.387.377-.7.515-1.021a.469.469,0,0,1,.69-.3c0,.614.013,1.248-.014,1.881,0,.094-.2.179-.307.27l-.109-.086V8.267l-.087-.023c-.138.26-.271.525-.416.781-.179.315-.358.318-.535.007a5.939,5.939,0,0,0-.471-.77V9.413c-.336.135-.481.076-.474-.268.012-.582,0-1.164,0-1.758",
    transform: "translate(-8.312 -1.683)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24374",
    "data-name": "Path 24374",
    d: "M32.943,7.332c.247,0,.454,0,.662,0,.342.007.682.037.835.413.146.357-.049.608-.308.829l.509.859c-.766.3-.68-.639-1.2-.783-.013.284-.024.525-.036.8h-.458Zm.49,1.071a2.042,2.042,0,0,0,.5-.237.332.332,0,0,0-.011-.325,1.809,1.809,0,0,0-.494-.17Z",
    transform: "translate(-7.565 -1.683)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24375",
    "data-name": "Path 24375",
    d: "M42.662,7.332c.247,0,.479-.005.712,0,.317.008.629.063.757.4a.656.656,0,0,1-.309.831l.536.885c-.31.045-.541.094-.692-.2-.107-.211-.25-.4-.376-.6l-.138.038c-.015.249-.029.5-.045.776l-.445.029Zm.6.3c-.037.041-.074.082-.112.122v.56c.287.042.549.007.518-.311-.014-.136-.263-.248-.406-.371",
    transform: "translate(-9.796 -1.683)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24376",
    "data-name": "Path 24376",
    d: "M46.309,8.306l.74,1.13a.6.6,0,0,1-.788-.3c-.137-.215-.185-.579-.615-.547v.87l-.5.028V7.355l.488-.024v.805l.126.078a4.918,4.918,0,0,0,.465-.585c.172-.3.41-.341.767-.263l-.683.94",
    transform: "translate(-10.367 -1.683)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24377",
    "data-name": "Path 24377",
    d: "M25.515,7.358h.49V8.532c0,.287.062.549.415.549s.428-.253.432-.543c0-.386,0-.771,0-1.178h.461A12.53,12.53,0,0,1,27.3,8.834a.908.908,0,0,1-1.781-.149c-.021-.428,0-.857,0-1.327",
    transform: "translate(-5.858 -1.69)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24378",
    "data-name": "Path 24378",
    d: "M41.725,9.452c-.312.1-.485.057-.609-.23-.046-.107-.267-.185-.411-.193-.179-.009-.441-.131-.518.18s-.283.334-.6.255c.26-.676.5-1.347.8-1.994.032-.069.515-.062.552.02.294.636.531,1.3.788,1.961M40.652,7.809l-.263.846h.552l-.29-.846",
    transform: "translate(-9.091 -1.705)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24379",
    "data-name": "Path 24379",
    d: "M31.887,8.594h-.6v.492h.817c.069.256.075.415-.227.408-.357-.009-.715,0-1.1,0V7.364H32.1c.027.243.027.243-.825.418v.387c.626.129.626.129.609.424",
    transform: "translate(-7.068 -1.691)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24380",
    "data-name": "Path 24380",
    d: "M28.851,8.767c-.015.237-.027.441-.041.679h-.454V7.334c.28,0,.552-.012.824,0,.487.025.76.285.76.7s-.26.669-.752.712c-.1.008-.191.011-.337.018m0-1.048v.66c.285,0,.577.046.578-.343,0-.364-.28-.333-.578-.317",
    transform: "translate(-6.511 -1.683)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24381",
    "data-name": "Path 24381",
    d: "M49.294,7.371c-.069.641-.6.179-.857.456v.321c.192.2.663-.132.637.418l-.65.048c-.006.15-.012.283-.021.468h.85v.387H47.938v-2.1Z",
    transform: "translate(-11.008 -1.693)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24382",
    "data-name": "Path 24382",
    d: "M23.3,9.225c.086-.321.243-.317.5-.2.12.056.314-.047.474-.078-.084-.118-.143-.3-.257-.342-.3-.123-.662-.2-.639-.594a.951.951,0,0,1,.329-.606.848.848,0,0,1,.994.118c-.031.358-.233.266-.467.208-.112-.028-.255.071-.384.112.076.1.134.239.233.28.321.133.726.208.673.655a.939.939,0,0,1-.392.613.918.918,0,0,1-1.065-.17",
    transform: "translate(-5.35 -1.675)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24383",
    "data-name": "Path 24383",
    d: "M50.986,9.469H50.48V7.782c-.592-.086-.592-.086-.565-.428h1.606c.043.351.043.351-.535.416Z",
    transform: "translate(-11.46 -1.689)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24384",
    "data-name": "Path 24384",
    d: "M6.178,22.028h6.638V36.711H6.178Zm5.3,1.352H7.523v12H11.48Z",
    transform: "translate(-1.419 -5.058)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24385",
    "data-name": "Path 24385",
    d: "M16.6,22.036h3.286v1.317H17.929V35.382h1.949v1.326H16.6Z",
    transform: "translate(-3.811 -5.06)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6320",
    "data-name": "Rectangle 6320",
    width: 1.285,
    height: 2.632,
    transform: "translate(30.651 29.255)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6321",
    "data-name": "Rectangle 6321",
    width: 1.285,
    height: 2.622,
    transform: "translate(26.199 29.264)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupermarket);
export default __webpack_public_path__ + "static/media/supermarket.ba65f4ea82b3c0aea5d5cfa9de345e96.svg";
export { ForwardRef as ReactComponent };